import {
  LearnersStudentPreferencesSubjectPreferenceSet,
  LearnersStudentPreferencesSubjectPreferenceSetAllTrait,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexPageProps = {
  templates: SelectOption<number>[]
}

export type EditPageProps = {
  template: Array<
    LearnersStudentPreferencesSubjectPreferenceSet &
      LearnersStudentPreferencesSubjectPreferenceSetAllTrait
  >
  template_name: string
  added_preference_id: string | null
}

export const useIndexProps = () => useProps<IndexPageProps>()
export const useEditProps = () => useProps<EditPageProps>()
